import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {action} from 'redux/helpers';
import {loginTypes} from 'features/login/redux';
import Loader from 'components/Loader';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';

export const SamlCallback: ReactFChildrenProps = () => {
   const dispatch = useDispatch();
   const location = useLocation();
   const navigate = useNavigate();

   useEffect(() => {
      const handleSamlData = () => {
         // Get the data from the URL
         const params = new URLSearchParams(location.search);
         const encodedData = params.get('data');

         if (encodedData) {
            try {
               // Decode the base64 encoded JSON
               const jsonStr = atob(encodedData);
               const responseData = JSON.parse(jsonStr);

               // Dispatch the login success action with the response data
               dispatch(action(loginTypes.LOGIN.SUCCESS, responseData));

               // Redirect to the main application
               navigate('/');
            } catch (error) {
               console.error('Error processing SAML data:', error);
               navigate('/login');
            }
         } else {
            // No data found, redirect to login
            navigate('/login');
         }
      };

      handleSamlData();
   }, [dispatch, navigate, location]);

   return <Loader />;
};
